"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.omitProps = exports.omit = exports.CleanTag = void 0;

var _react = _interopRequireDefault(require("react"));

var _excluded = ["is", "omitFromProps"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The default set of props to remove from components rendered by styled-components
 */
var omitProps = ["backgroundColor", "bg", "borderRadius", "color", "display", "fontFamily", "fontSize", "fontStyle", "fontWeight", "height", "letterSpacing", "lineHeight", "m", "maxHeight", "maxWidth", "mb", "minHeight", "minWidth", "ml", "mr", "mt", "mx", "my", "p", "pb", "pl", "pr", "pt", "px", "py", "textAlign", "theme", "width"];
/**
 * Removes entries from an object based on a list of keys
 */

exports.omitProps = omitProps;

var omit = function omit() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var keys = arguments.length > 1 ? arguments[1] : undefined;
  var next = {};

  for (var key in obj) {
    if (keys.indexOf(key) > -1) continue;
    next[key] = obj[key];
  }

  return next;
};

exports.omit = omit;

var tagName = function tagName(tag) {
  return typeof tag === "string" ? tag : tag.displayName || "Tag";
};

function tagBuilder() {
  var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "div";

  var TagComponent = /*#__PURE__*/_react.default.forwardRef(function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$is = _ref.is,
        BaseTag = _ref$is === void 0 ? tag : _ref$is,
        _ref$omitFromProps = _ref.omitFromProps,
        omitFromProps = _ref$omitFromProps === void 0 ? [] : _ref$omitFromProps,
        props = _objectWithoutProperties(_ref, _excluded);

    var ref = arguments.length > 1 ? arguments[1] : undefined;
    return props ? /*#__PURE__*/_react.default.createElement(BaseTag, _objectSpread({
      ref: ref
    }, omit(props, [].concat(_toConsumableArray(omitFromProps), omitProps)))) : /*#__PURE__*/_react.default.createElement(BaseTag, {
      ref: ref
    });
  });

  TagComponent.displayName = "Clean.".concat(tagName(tag));
  return TagComponent;
}

var DefaultTag = tagBuilder();
/**
 * An element to be used to prevent unwanted props from passing through
 * styled-components to the DOM
 *
 * @example
 *
 * const Component = styled(Tag)`
 *   ${borderRadius};
 * `
 *
 * const Component2 = styled(Tag.as('span'))`
 *  ${background};
 * `
 */

var CleanTag = DefaultTag;
exports.CleanTag = CleanTag;
CleanTag.as = tagBuilder;
//# sourceMappingURL=CleanTag.js.map